export const validFoedselsdato = (date: string): boolean => {
    const foedselsdato = date.replace(/\D/g, '').match(/(\d{0,2})(\d{0,2})(\d{0,4})/);
    const now = new Date();
    if (foedselsdato !== null) {
        const inputDate = new Date(`${foedselsdato[3]}-${foedselsdato[2]}-${foedselsdato[1]}`);
        return inputDate < now && now.getFullYear() - inputDate.getFullYear() <= 18;
    }
    return true;
};

export const maskFoedselsdato = (dato: string): string => {
    const foedselsdato = dato.replace(/\D/g, '').match(/(\d{0,2})(\d{0,2})(\d{0,4})/);
    if (foedselsdato !== null) {
        if (foedselsdato[3]) return `${foedselsdato[1]}.${foedselsdato[2]}.${foedselsdato[3]}`;
        if (foedselsdato[2]) return `${foedselsdato[1]}.${foedselsdato[2]}`;
        if (foedselsdato[1]) return foedselsdato[1];
    }
    return '';
};

export const getYear = (date: string | null): string => {
    if (date) {
        const dato = new Date(date);
        return dato.getFullYear().toString();
    }
    return '';
};
